export default __webpack_public_path__ + "static/media/image.2db80375.png";